import React, { useState, useEffect, Fragment, useRef } from "react";
import "./ActivityData.scss";
import { DatePicker } from "antd";
import FileAttachmentsDetails from "../../common/FileAttachmentsDetails";
import {
  Card,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Select,
  MenuItem,
  TextField,
  CircularProgress,
} from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
import AttachmentIcon from "@mui/icons-material/Attachment";
import {
  createEmissionService,
  getEmissionCurrencyService,
  getEmissionFactorsService,
  getEmissionTypesService,
} from "../../../services/emissionService";
import { toastMessage } from "../../../helper";
import { neutral } from "../../../constants/colorConstants";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import { Cascader, Select as AntSelect } from "antd";
import { ClickAwayListener } from "@mui/base";
import moment from "moment";
import { CaretDownOutlined } from "@ant-design/icons";
import {
  CATEGORY_CODE,
  EMISSION_METHOD_NAME,
  EMISSION_TYPE,
  EMISSION_SUB_TYPE,
  STEPS,
  MODULE_GROUP,
} from "../../../constants/enums";
import { useTranslation } from "react-i18next";
import FileAttachments from "../../common/FileAttachments";

function filter(inputValue: string, path: any) {
  return path.some(
    (option: any) =>
      option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1
  );
}

const ActivityData = (props: any) => {
  const {
    selectedCategory,
    setStep,
    setEmissionData,
    categoryPreferences,
    businessUnitPreference,
    isDirectEmissionApprovalEnable,
  } = props;
  // const { RangePicker } = DatePicker;
  const navigate = useNavigate();
  // const [sourceList, setSourceList] = useState([] as any);
  const [sourceList, setSourceList] = useState([] as any);
  const [typeList, setTypeList] = useState([] as any);
  const [emissionMethod, setEmissionMethod] = useState<any>({});
  const [currentIndex, setCurrentIndex] = useState(-1);
  const [showAttachment, setShowAttachment] = useState(false);
  const [sourceAttachmentData, setSourceAttachmentData] = useState({
    attachments: [],
  });
  const [isShowMultiLevelDropdown, setIsShowMultiLevelDropdown] =
    useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const inputRef = useRef<HTMLElement>(null);
  const { Option } = AntSelect;
  const { t, i18n } = useTranslation();

  const [cellColumns, setCellColumns] = useState([
    "Sources",
    "Method Type",
    "",
    "",
    "",
  ]);
  const [selectedSourceList, setSelectedSourceList] = useState([] as any);
  const [searchText, setSearchText] = useState("");
  const [formData, setFormData] = useState<any>({
    company:
      localStorage.getItem("company") &&
      JSON.parse(localStorage.getItem("company") || "").id,
    businessUnit:
      localStorage.getItem("currentBusinessUnit") &&
      JSON.parse(localStorage.getItem("currentBusinessUnit") || "").id,
    country: 1,
    method: "",
    scope: "",
    parent: selectedCategory.parent,
    attachments: [],
    from: new Date(new Date().getFullYear(), new Date().getMonth(), 2),
    to: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0),
    category: selectedCategory.id,
    categoryCode: selectedCategory.code,
    emissionSources: [] as any,
    notes: "",
  });
  // const [methodsList, setMethodsList] = useState([] as any);
  const onChangeDate = (e: any) => {
    if (!e) {
      setFormData({ ...formData, from: null, to: null });
      return;
    }
    let startDate = new Date(e.$d);
    console.log("startDate before", startDate);
    startDate = new Date(startDate.getFullYear(), startDate.getMonth(), 2);
    startDate.setHours(0, 0, 0, 0);
    if (
      startDate.getFullYear() > new Date().getFullYear() ||
      (startDate.getFullYear() === new Date().getFullYear() &&
        startDate.getMonth() > new Date().getMonth())
    ) {
      toastMessage("Selection of future date is not recommended.", "warning");
    }
    let endDate = new Date(e.$d);
    console.log("endDate before", endDate);
    endDate = new Date(startDate.getFullYear(), startDate.getMonth() + 1, 0);
    console.log("endDate after", endDate);
    endDate.setHours(0, 0, 0, 0);
    setFormData({ ...formData, from: startDate, to: endDate });
  };
  const onChange = (event: any) => {
    if (event.target.name === "comments") {
      setFormData({ ...formData, [event.target.name]: event.target.value });
    }
  };
  const getSourceKey = (eachSource: any) => {
    return eachSource.emission_key
      ? eachSource.emission_key
      : eachSource.emissionfactorid
      ? eachSource.emissionfactorid
      : eachSource.emissionsource;
  };
  const getUomName = (eachSource: any) => {
    return (
      eachSource.uoms && eachSource.uoms.length
        ? eachSource.uoms[0].name
          ? eachSource.uoms[0].name
          : eachSource.uoms[0].symbol
        : eachSource.uomsymbol
    ).split("/")[1];
  };
  const saveAttachments = (sourceData: any) => {
    const requiredIndex = sourceList.findIndex((each: any) => {
      return getSourceKey(each) === getSourceKey(sourceData);
    });
    const updatedSourceList = sourceList;
    updatedSourceList[requiredIndex].attachments = [...sourceData.attachments];
    setSourceList([...updatedSourceList]);
  };
  const onChangeUnits = (e: any, index: number) => {
    if (!isNaN(e.target.value)) {
      const resList: any = sourceList
        .filter((eachSource: any) => eachSource.selected)
        .sort((s1: any, s2: any) => {
          return s1.selectedTime - s2.selectedTime;
        });
      resList[index].units = e.target.value;
      setSelectedSourceList([...resList]);
      // [{name:"Bunit 1",incharge:"Smith",type:"Manufacturing",id:99,status:"In Active",registrationId:"WWJTTY"},{name:"Bunit 2",incharge:"Warner",type:"Design",id:98,status:"active",registrationId:"WWJTTY-A"},{name:"Bunit 3",incharge:"Warner",type:"Design",id:97,status:"active",registrationId:"WWJTTY-A"},{name:"Bunit 4",incharge:"Warner",type:"Design",id:96,status:"active",registrationId:"WWJTTY-c"},{name:"Bunit 5",incharge:"Warner",type:"Design",id:95,status:"active",registrationId:"WWJTTY-A"}];
      // resList.map((eachUnit: any) => (eachUnit.selected = false));
      setSourceList([...sourceList]);
      setCurrentIndex(index);
    }
  };

  useEffect(() => {
    getEmissionSources();
  }, []);
  const isValidForm = () => {
    return (
      formData.from &&
      formData.to &&
      sourceList?.filter(
        (eachSource: any) =>
          eachSource.selected &&
          (eachSource.uoms || eachSource.uomsymbol) &&
          eachSource.units > 0
      )?.length
    );
  };
  const [sourceName, setSourceName] = React.useState("NA");
  const createEmissionLog = () => {
    setIsLoading(true);
    let reqData: any = formData;
    reqData.from.setHours(0, 0, 0, 0);
    reqData.to.setHours(0, 0, 0, 0);
    reqData.protocol = localStorage.getItem("protocol");
    console.log("reqData", reqData);
    let user = JSON.parse(localStorage.getItem("user") || "{}");
    reqData.displayName = user.displayName
      ? user.displayName
      : user.email.split("@")[0];
    let key =
      localStorage.getItem("protocol") == "ghg" ? "ghgCategory" : "category";
    let categoryPreference = (
      categoryPreferences?.length
        ? categoryPreferences
        : JSON.parse(localStorage.getItem("categoryPreferences") || "")
    ).find(
      (eachPreference: any) => eachPreference[key] === selectedCategory.id
    );
    if (categoryPreference) {
      categoryPreference.emissionSubType &&
        (reqData.subtype = categoryPreference.emissionSubType);
      categoryPreference.emissionType &&
        (reqData.type = categoryPreference.emissionType);
      reqData.method = selectedCategory.method
        ? selectedCategory.method
        : categoryPreference.methods.find((each: any) => each.selected).id;
    }

    let activeList = sourceList
      .filter((eachSource: any) => eachSource.selected)
      .map((src: any) => {
        let eachSource = { ...src };
        eachSource.emissionSource = eachSource.emissionsource;
        let uom = eachSource.uoms && eachSource.uoms[0];
        if (eachSource.uoms?.length > 1) {
          uom = { id: eachSource.uom, symbol: eachSource.symbol };
        }
        eachSource.uoms ? delete eachSource.uoms : delete eachSource.uomsymbol;
        delete eachSource.emissionsource;
        delete eachSource.emissionmethodname;
        uom && (eachSource.uom = uom.id);
        eachSource.value = eachSource.units;
        eachSource.uomName = uom
          ? uom.symbol
            ? uom.symbol
            : uom.name
          : eachSource.symbol
          ? eachSource.symbol
          : eachSource.uomsymbol;
        eachSource.attachments = { files: eachSource.attachments };
        eachSource.symbol = uom
          ? uom.symbol
            ? uom.symbol
            : uom.name
          : eachSource.uomsymbol;
        eachSource.country = eachSource.country;
        return eachSource;
      });
    reqData.emissionSources = activeList;
    reqData.status = isDirectEmissionApprovalEnable ? "Approved" : "Pending";
    console.log(reqData);
    let req = { ...reqData };
    req.attachments = { files: req.attachments };
    delete req.country;
    createEmissionService(req)
      .then((res) => {
        setEmissionData({ ...res.data });
        toastMessage("Emission Log Creation Successful", "success");
        setStep(STEPS.EMISSION_SUMMARY);
      })
      .catch((e) => {
        toastMessage(e.response.data.message, "error");
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const getEmissionSources = () => {
    // setMethodsList([]);
    //method  'Distance Travelled' 'Fuel Consumed'
    // if (
    //   selectedCategory?.code === "Category 1.2" ||
    //   selectedCategory?.code === "Category 2.1" ||
    //   selectedCategory?.code === "Category 3.3"
    // ) {
    let params: any = {};
    {
      /* ToBeModified */
    }
    let key =
      localStorage.getItem("protocol") == "ghg" ? "ghgCategory" : "category";
    let categoryPreference = (
      categoryPreferences?.length
        ? categoryPreferences
        : JSON.parse(localStorage.getItem("categoryPreferences") || "")
    ).find(
      (eachPreference: any) => eachPreference[key] === selectedCategory.id
    );
    if (categoryPreference) {
      categoryPreference.emissionSubType &&
        (params.subtype = categoryPreference.emissionSubType.toString());
      categoryPreference.emissionType &&
        (params.type = categoryPreference.emissionType.toString());
      params.method = selectedCategory.method
        ? selectedCategory.method
        : categoryPreference.methods.find((each: any) => each.selected).id;
    }
    getEmissionTypesService(params).then((typeRes) => {
      if (typeRes.data?.length) {
        const emissionMethod = typeRes.data.find(
          (eachType: any) => eachType.moduleGroup === MODULE_GROUP.GROUP_2
        );
        setEmissionMethod(emissionMethod);

        setSourceName(
          typeRes.data.find(
            (eachType: any) =>
              eachType.moduleGroup === MODULE_GROUP.GROUP_19 ||
              eachType.moduleGroup === MODULE_GROUP.GROUP_15
          ).name
        );

        params.categoryId = selectedCategory.id.toString();
        getEmissionFactorsService(params)
          .then(async (res) => {
            let sourceList;
            let isShowMultiLevelDropdown;
            if (res?.data[0]?.level1_status?.length) {
              sourceList = res.data[0].level1_status;
              setSourceList(sourceList);
            } else if (res?.data[0]?.level2_status?.length) {
              sourceList = res.data[0].level2_status;
              setSourceList(sourceList);
            } else if (res?.data[0]?.level3_status?.length) {
              isShowMultiLevelDropdown = true;
              setIsShowMultiLevelDropdown(isShowMultiLevelDropdown);
            }

            let columns = cellColumns;
            if (isShowMultiLevelDropdown) {
              columns[1] = "Activity Data";
              setTypeList(res.data[0].level3_status);
            } else {
              sourceList.map((source: any) => {
                source.selectedTime = 0;
                source.attachments = [];
              });
              columns[1] = "Activity Data";
              let currencySymbol = "";
              if (
                selectedCategory?.code === CATEGORY_CODE.CATEGORY_4_1 &&
                emissionMethod.name ===
                  EMISSION_METHOD_NAME.CRADLE_TO_PRODUCTION
              ) {
                var currencies = (
                  await getEmissionCurrencyService()
                ).data.filter((item: any) => item.symbol == "USD");
                currencySymbol = "USD";
                //  currencies.find(
                //   (each: any) => each.id === businessUnitPreference.currency
                // ).symbol;
              }
              sourceList.map((eachUnit: any) => {
                eachUnit.selected = sourceList.length < 10;
                eachUnit.units = 0;
                if (
                  selectedCategory?.code === CATEGORY_CODE.CATEGORY_4_1 &&
                  emissionMethod.name ===
                    EMISSION_METHOD_NAME.CRADLE_TO_PRODUCTION
                ) {
                  // eachUnit.uom = businessUnitPreference.currency;
                  eachUnit.uom = currencies[0].id;
                  console.log("uoms = {}", currencies);
                  eachUnit.uoms = currencies;
                  eachUnit.symbol = currencySymbol;
                } else {
                  eachUnit.uom = eachUnit.uom || eachUnit.uoms[0].id;
                  eachUnit.symbol =
                    eachUnit.uomsymbol || eachUnit.uoms[0].symbol;
                }
                return eachUnit;
              });
              setSourceList(sourceList);
            }

            setCellColumns([...columns]);
          })
          .catch((e) => {
            toastMessage(e.response.data.message, "error");
          });
      }
    });

    // }
  };
  const handleChange = (event: any) => {
    //let source = JSON.parse(event.target.value);
    let srcList = sourceList;
    let index = srcList.findIndex(
      (eachSource: any) => getSourceKey(eachSource) === event
    );
    index > -1 &&
      (srcList[index].selected = true) &&
      (srcList[index].selectedTime = moment().valueOf());

    setSelectedSourceList([...selectedSourceList, srcList[index]]);
    setSourceList([...srcList]);
    console.log("selected");
    setSearchText("");
  };

  const handleTypeChange = (event: any) => {
    let typList = typeList;
    let typeIndex = typeList.findIndex(
      (eachSource: any) => eachSource.value === event[0]
    );
    let subTypeIndex =
      event.length > 1
        ? typeList[typeIndex].children.findIndex(
            (eachSource: any) => eachSource.value === event[1]
          )
        : null;

    let srcList = sourceList;
    let index = srcList.findIndex(
      (eachSource: any) => getSourceKey(eachSource) === event.toString()
    );

    if (index === -1) {
      let srcObject = {
        ...typList[typeIndex],
        units: 0,
        emission_key: event.toString(),
        selected: true,
        emissionsource: typList[typeIndex].emission_source
          ? typList[typeIndex].emission_source
          : typList[typeIndex].emissionsource,
        emissionsourcename: typList[typeIndex].emissionsourcename,
        emissionmethod: emissionMethod.id,
        emissionmethodname: emissionMethod.name,
      };
      if (typList[typeIndex].emission_source_sub_type) {
        srcObject.emissionsourcesubtype =
          typList[typeIndex].emission_source_sub_type;
      }
      if (typList[typeIndex].uoms.length) {
        srcObject.uom = typList[typeIndex].uoms[0].id;
        srcObject.symbol = typList[typeIndex].uoms[0].symbol;
      }
      if (event.length > 1) {
        if (
          (selectedCategory?.code === CATEGORY_CODE.CATEGORY_3_1 ||
            selectedCategory?.code === CATEGORY_CODE.CATEGORY_3_2) &&
          emissionMethod?.name ===
            EMISSION_METHOD_NAME.DISTANCE_TRAVELLED_BY_LOGISTICS_TYPE
        ) {
          srcObject.fuel = parseInt(event[1]);
          srcObject.engine_name =
            typList[typeIndex].children[subTypeIndex].label;
        } else {
          srcObject.engine_name =
            typList[typeIndex].children[subTypeIndex].label;
          srcObject.engine_type = parseInt(event[1].split(" - ")[0]);
          srcObject.fuel = parseInt(event[1].split(" - ")[1]);
        }
      }
      srcList.push(srcObject);
      setCurrentIndex(srcList.length - 1);
      setSourceList([...srcList]);
    } else {
      toastMessage("Selected type already exists !!", "warning");
    }
  };

  const handleUOMChange = (event: any, sourceIndex: number) => {
    let srcList = sourceList;
    const resList: any = sourceList
      .filter((eachSource: any) => eachSource.selected)
      .sort((s1: any, s2: any) => {
        return s1.selectedTime - s2.selectedTime;
      });
    let uom = resList[sourceIndex].uoms.find(
      (eachUom: any) => eachUom.id === event.target.value
    );

    resList[sourceIndex].uom = uom.id;
    resList[sourceIndex].uomName = uom
      ? uom.symbol
      : resList[sourceIndex].uomsymbol;
    resList[sourceIndex].symbol = uom
      ? uom.symbol
      : resList[sourceIndex].uomsymbol;
    console.log();
    setSourceList([...srcList]);
  };
  const handleDelete = (emissionsource: number) => {
    // setSourceListDropDown(
    //   sourceListDropDown.filter((each: any) => each !== props)
    // );
    let srcList = sourceList;
    let index = srcList.findIndex(
      (eachSource: any) => getSourceKey(eachSource) === emissionsource
    );
    if (index > -1) {
      srcList[index].attachments = [];
    }
    index > -1 && (srcList[index].selected = false);
    const temp = srcList.filter((eachSource: any) => eachSource.selected);
    setSelectedSourceList([...temp]);
    setSourceList([...srcList]);
    console.log("Clicked");
  };
  const openLogAttachment = (source: any) => {
    setShowAttachment(true);
    setSourceAttachmentData(source);
  };
  useEffect(() => {
    if (
      (sourceList.length >= 10 || isShowMultiLevelDropdown) &&
      inputRef.current
    ) {
      inputRef.current.focus();
    }
  }, [sourceList]);
  return (
    <Fragment>
      <div className="pw-activity-data-main w-55v overflow-y-auto flex flex-col gap-10">
        <div>
          <div className="pw-input-label pw-create-label">
            {t("Log Values")}
          </div>
          <div className="flex flex-row justify-between items-center pw-border-bottom pb-2">
            <div className="flex flex-row gap-1">
              <p className="text-sm text-neutral-600">
                {t("Preferred emission factor")}
              </p>
              <p className="text-sm text-neutral-900">{sourceName}</p>
            </div>
            <div className="flex flex-row gap-1">
              <p className="text-sm text-neutral-600">
                {t("Log emission against")}
              </p>
              <p className="text-sm text-neutral-900">
                {emissionMethod.name || "-"}
              </p>
            </div>
          </div>
        </div>
        <div>
          <div className="pw-range-label pb-1.5 text-neutral-600">
            {t("Range")}
          </div>
          {/* <RangePicker 
            className="pw-date-range"
            picker="month"
            onChange={onChangeDate}
          /> */}
          <DatePicker
            picker="month"
            className="pw-date-range bg-white"
            defaultValue={dayjs(formData.from)}
            onChange={onChangeDate}
          />
        </div>
        <div>
          <Card>
            <Table size="small" className="pw-activitydata-table">
              <TableHead className="pw-activity-table-head">
                <TableRow>
                  {cellColumns.map((eachCell, index) => (
                    <TableCell
                      key={index}
                      className={`pw-activity-list ${
                        index === 0 || index === 2
                          ? "pw-major-row"
                          : "pw-minor-rows"
                      }`}
                      align={
                        index === 2 ? "center" : index === 1 ? "right" : "left"
                      }
                    >
                      {t(eachCell)}
                    </TableCell>
                  ))}
                </TableRow>
                <TableRow></TableRow>
              </TableHead>

              <TableBody className="pw-actitvity-table-row">
                {sourceList.length <= 2 || true ? (
                  sourceList
                    .filter((eachSource: any) => eachSource.selected)
                    .sort((s1: any, s2: any) => {
                      return s1.selectedTime - s2.selectedTime;
                    })
                    .map((eachSource: any, index: number) => (
                      <TableRow
                        key={getSourceKey(eachSource)}
                        // className={`pw-selected-row-${eachSource.selected}`}
                      >
                        <TableCell className="pw-row pw-major-row !text-neutral-900">
                          <div className="pw-emission-label">
                            {eachSource?.label || eachSource.emissionsourcename}
                          </div>
                          {eachSource.engine_name ? (
                            <div className="text-neutral-600 text-xs">
                              {eachSource.engine_name}
                            </div>
                          ) : (
                            ""
                          )}
                        </TableCell>
                        <TableCell className="!text-neutral-600">
                          <TextField
                            inputRef={
                              currentIndex === -1 || currentIndex === index
                                ? inputRef
                                : undefined
                            }
                            sx={{ input: { textAlign: "right" } }}
                            type="text"
                            variant="standard"
                            placeholder="units"
                            size="small"
                            name="units"
                            value={
                              eachSource.units === 0 ? "" : eachSource.units
                            }
                            onChange={(e) => onChangeUnits(e, index)}
                            className="pw-width-100 pw-input-field pw-input-text pw-activity-input"
                            InputProps={{
                              style: {
                                color: neutral[900],
                                fontSize: 14,
                              },
                            }}
                          />
                        </TableCell>
                        <TableCell align="left" className="!text-neutral-600">
                          {eachSource.uom && eachSource.uoms?.length > 0 ? (
                            <Select
                              className="pw-emission-select w-50vh pb-2 gap-5 e2e-pw-uomselect"
                              size="small"
                              value={eachSource.uom}
                              onChange={(event: any) => {
                                handleUOMChange(event, index);
                              }}
                            >
                              {eachSource.uoms.map((eachUOM: any) => (
                                <MenuItem value={eachUOM.id}>
                                  {selectedCategory.code ===
                                    CATEGORY_CODE.CATEGORY_4_1 &&
                                  emissionMethod.name ===
                                    EMISSION_METHOD_NAME.CRADLE_TO_PRODUCTION
                                    ? eachUOM.symbol
                                    : eachUOM.symbol.split("/")[1]}
                                </MenuItem>
                              ))}
                            </Select>
                          ) : (
                            <p className="pw-uom-name">
                              {getUomName(eachSource)}
                            </p>
                          )}
                        </TableCell>
                        <TableCell>
                          <div
                            onClick={() => openLogAttachment(eachSource)}
                            className="pw-attachment-icon cursor-pointer"
                          >
                            <AttachmentIcon className="pw-rotate-50" />
                            {eachSource?.attachments?.length > 0 && (
                              <div className="pw-attachment-count">
                                {eachSource?.attachments?.length}
                              </div>
                            )}
                          </div>
                        </TableCell>
                        <TableCell>
                          <CancelIcon
                            className="text-neutral-400 pw-ativity-icon"
                            onClick={() => {
                              handleDelete(getSourceKey(eachSource));
                            }}
                          />
                        </TableCell>
                      </TableRow>
                    ))
                ) : (
                  <div></div>
                )}
                {sourceList.filter((eachSource: any) => !eachSource.selected)
                  .length || isShowMultiLevelDropdown ? (
                  <TableRow className="h-14 pw-dropdown">
                    <TableCell>
                      <div
                        className="flex flex-row"
                        id="pw-emissionsource-select"
                      >
                        {!isShowMultiLevelDropdown ? (
                          <ClickAwayListener
                            onClickAway={() => {
                              setSearchText("");
                            }}
                          >
                            <AntSelect
                              onSelect={() => {
                                setCurrentIndex(-1);
                              }}
                              suffixIcon={
                                <CaretDownOutlined className="!pointer-events-none" />
                              }
                              dropdownStyle={{ minWidth: "35%" }}
                              showSearch
                              style={{ width: 200 }}
                              className="pw-source-select"
                              placeholder={t("Select")}
                              value={[]}
                              onChange={(e) => handleChange(e)}
                              filterOption={(input, option: any) => {
                                console.log("option :", option);
                                let sourceObj = sourceList.find(
                                  (opt: any) =>
                                    opt.emissionfactorid === option.value
                                );
                                return sourceObj?.emissionsourcename
                                  ?.toLowerCase()
                                  ?.includes(input.toLowerCase());
                              }}
                            >
                              {sourceList
                                .filter(
                                  (eachsource: any) => !eachsource.selected
                                )
                                .map((eachSource: any, index: number) => (
                                  <Option
                                    key={index}
                                    value={
                                      eachSource.emissionfactorid
                                        ? eachSource.emissionfactorid
                                        : eachSource.emissionsource
                                    }
                                  >
                                    {eachSource.emissionsourcename}
                                  </Option>
                                ))}
                            </AntSelect>
                          </ClickAwayListener>
                        ) : (
                          <Cascader
                            suffixIcon={
                              <CaretDownOutlined className="!pointer-events-none" />
                            }
                            className="pw-source-select"
                            options={typeList}
                            onChange={handleTypeChange}
                            value={[]}
                            placeholder="Please select"
                            showSearch={{ filter }}
                          />
                        )}
                      </div>
                    </TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                ) : (
                  ""
                )}
              </TableBody>
            </Table>
          </Card>
        </div>
        <div>
          {" "}
          <FileAttachmentsDetails
            formData={formData}
            setFormData={setFormData}
          />
        </div>
        <div className="flex flex-col gap-2 items-start">
          <p className="text-sm text-neutral-600">{t("Notes")}</p>
          <textarea
            name="comments"
            onChange={(e) => onChange(e)}
            className="pw-notes-area pw-address"
            placeholder={t("Notes")}
          ></textarea>
        </div>
      </div>
      <div className="flex flex-row justify-end pw-bunit-footer w-full gap-6">
        <div
          className="pw-bunit-button-light pw-bunit-button-next text-neutral bg-white font-bold"
          onClick={() => navigate("/log/emissions")}
        >
          {t("Cancel")}
        </div>
        <div
          className={`pw-bunit-button-primary pw-bunit-button-save text-white  
          ${
            isValidForm()
              ? isLoading
                ? "text-black bg-neutral-300"
                : "cursor-pointer bg-primary"
              : "text-black bg-neutral-300"
          }`}
          onClick={() => isValidForm() && !isLoading && createEmissionLog()}
        >
          {isLoading ? (
            <div className="flex flex-row gap-2 p-2">
              <span>{t("Saving up")}</span>
              <CircularProgress size={20} />
            </div>
          ) : (
            <span>{t("Save")}</span>
          )}
        </div>
      </div>
      {showAttachment && (
        <FileAttachments
          sourceAttachmentData={sourceAttachmentData}
          setSourceAttachmentData={setSourceAttachmentData}
          showAttachment={showAttachment}
          setShowAttachment={setShowAttachment}
          saveAttachments={saveAttachments}
          cellColumns={cellColumns}
        />
      )}
    </Fragment>
  );
};
export default ActivityData;
